const translations = {
  en: {
    nav: {
      home: 'Home',
      industries: 'Industries',
      services: 'Services',
      about: 'About',
      contact: 'Contact',
      getStarted: 'Get Started',
    },
    footer: {
      tagline: 'Leading the digital transformation in Architecture, Engineering, and Construction with innovative BIM and LiDAR solutions.',
      quickLinks: 'Quick Links',
      ourServices: 'Our Services',
      contactUs: 'Contact Us',
      aboutUs: 'About Us',
      allRightsReserved: 'All rights reserved.',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      cookiePolicy: 'Cookie Policy',
      servicesList: ['Point Cloud Processing', 'As-Built BIM Modeling', '3D Rendering & Visualization', 'Digital Twins', 'LiDAR Mapping', 'Scan to CAD'],
    },
    home: {
      heroTag: 'Advanced Point Cloud & 3D Scanning Solutions',
      heroTitle1: 'Point Cloud Excellence',
      heroTitle2: 'Meets Precision',
      heroDescription: 'Leading the industry with state-of-the-art LiDAR scanning, point cloud processing, and scan-to-BIM services delivering millimeter accuracy for your most demanding projects.',
      requestConsultation: 'Request Consultation',
      exploreServices: 'Explore Services',
      pointCloudTitle: 'Specialized Point Cloud Services',
      pointCloudSubtitle: 'From initial capture to final deliverable, we transform reality into actionable digital data',
      pointCloudServices: [
        { title: 'As-Built BIM Modeling', description: 'Transform point clouds into intelligent BIM models for renovation and facility management' },
        { title: 'LiDAR Mapping', description: 'High-precision topographic surveys and terrain modeling for infrastructure projects' },
        { title: 'Virtual Tours', description: 'Immersive 360° walkthroughs for remote inspection and stakeholder collaboration' },
        { title: '2D CAD Drawings', description: 'Accurate floor plans, elevations, and sections extracted from scan data' },
        { title: 'Scan to CAD', description: 'Comprehensive conversion of raw point cloud data to clean CAD drawings' },
        { title: 'Architectural Scanning', description: 'Heritage preservation and detailed documentation of complex structures' },
      ],
      exploreAllServices: 'Explore All Services',
      industriesTitle: 'Industries We',
      industriesTitleAccent: 'Serve',
      industriesSubtitle: 'Delivering measurable value across Construction and Real Estate with integrated, technology-driven solutions.',
      learnMore: 'Learn More',
      vizTitle: 'Visualize Your Vision with',
      vizTitleAccent: '3D Rendering & Digital Twins',
      vizSubtitle: 'Bring your projects to life with photorealistic renderings and intelligent digital replicas',
      audiences: [
        {
          title: 'Real Estate Developers',
          description: 'Showcase properties before construction with stunning visualizations that drive pre-sales and investor confidence.',
          benefits: ['Pre-construction Marketing', 'Investor Presentations', 'Unit Customization Views'],
        },
        {
          title: 'Architectural & MEP Applications',
          description: 'Accurate as-built models and detailed MEP documentation that streamline design coordination, reduce clashes, and accelerate project delivery.',
          benefits: ['Capture Site Conditions', 'Design Coordination', 'Compare Built Work with Plans'],
        },
        {
          title: 'Contractors',
          description: 'Win more bids with professional visualizations and manage projects efficiently with digital twins.',
          benefits: ['Proposal Visuals', 'Construction Planning', 'Progress Tracking'],
        },
      ],
      whatWeDeliver: 'What We Deliver',
      deliverables: [
        'Photorealistic 3D renderings for marketing and presentations',
        'Interactive plan visualizations with multiple design options',
        'Digital twins with real-time data integration',
        'Virtual walkthroughs and immersive experiences',
        'Construction phasing animations',
        'Material and lighting studies',
      ],
      fromLabel: 'From',
      conceptToReality: 'Concept to Reality',
      conceptDescription: 'Transform your ideas into compelling visuals that communicate design intent and drive project success.',
      exploreVisualization: 'Explore Visualization Services',
      whyChooseTitle: 'Why Choose',
      whyChooseAccent: 'Delta Studio?',
      whyChooseDescription: 'We deliver integrated, technology-driven solutions that transform how you design, build, and manage projects. Our commitment to quality, precision, and innovation sets us apart.',
      whyChooseItems: [
        { title: 'Technical Excellence', description: 'Cutting-edge BIM and LiDAR technology deployed by certified experts with decades of combined experience.' },
        { title: 'Measurable Results', description: 'Proven track record of reducing costs, minimizing rework, and accelerating project timelines.' },
        { title: 'Trusted Partner', description: '500+ successful projects across residential, commercial, industrial, and institutional sectors.' },
      ],
      clientSatisfaction: 'Client Satisfaction',
      ctaTitle: 'Ready to Transform Your Project?',
      ctaDescription: "Let's discuss how our BIM and LiDAR solutions can help you achieve your project goals with precision and efficiency.",
      viewServices: 'View Services',
    },
    services: {
      heroTitle1: 'Comprehensive',
      heroTitleAccent: 'BIM & LiDAR',
      heroTitle2: 'Services',
      heroDescription: 'From design to construction and beyond, we provide end-to-end digital solutions that transform project delivery and enhance collaboration.',
      featuredTag: 'Featured Services',
      signatureTitle: 'Our',
      signatureTitleAccent: 'Signature Solutions',
      signatureSubtitle: 'Industry-leading capabilities in point cloud processing, visualization, and digital twin technology.',
      whyChooseService: 'Why Choose This Service?',
      serviceBenefits: {
        '1': [
          { title: 'Millimeter Accuracy', description: 'Capture reality with precision down to ±2mm' },
          { title: 'Rapid Data Capture', description: 'Scan large facilities in hours, not days' },
          { title: 'Complete Documentation', description: 'Every detail captured for future reference' },
          { title: 'Versatile Deliverables', description: 'BIM models, CAD drawings, virtual tours, and more' },
        ],
        '8': [
          { title: 'Photorealistic Quality', description: 'Stunning visuals that showcase design intent perfectly' },
          { title: 'Marketing Ready', description: 'Professional renderings for sales and marketing materials' },
          { title: 'Client Communication', description: 'Help clients visualize final results before construction' },
          { title: 'Design Validation', description: 'Validate design decisions early in the process' },
        ],
        '9': [
          { title: 'Real-Time Monitoring', description: 'Track asset performance and conditions 24/7' },
          { title: 'Predictive Maintenance', description: 'Anticipate issues before they become problems' },
          { title: 'Cost Savings', description: 'Optimize operations and reduce maintenance costs' },
          { title: 'Lifecycle Management', description: 'Manage assets from construction to decommissioning' },
        ],
      },
      portfolioTitle: 'Complete',
      portfolioTitleAccent: 'Service Portfolio',
      portfolioSubtitle: 'From initial scan to final deliverable, we provide comprehensive solutions for every project need.',
      keyFeatures: 'Key Features:',
      processTitle: 'Our',
      processTitleAccent: 'Process',
      processSubtitle: 'A structured approach to delivering excellence at every stage of your project.',
      processSteps: [
        { step: '01', title: 'Discovering', description: 'We begin by visiting your property to understand its unique features and determine the best areas to focus on. This helps us ensure every important detail is captured for an accurate model.' },
        { step: '02', title: 'Planning', description: 'Next, we craft a tailored plan for your project, selecting the ideal equipment and identifying the perfect scan points. Our goal is to create a smooth process that guarantees precision and efficiency.' },
        { step: '03', title: 'Execution', description: 'Our team then gets to work, carefully scanning the property from multiple angles. With our expert equipment and techniques, we capture every detail, ensuring a high-quality and accurate 3D representation.' },
        { step: '04', title: 'Delivery', description: "Once the scan data is processed, we deliver a stunning, interactive 3D model that's ready for you to explore, share, or integrate into your project. Providing comprehensive documentation and support." },
      ],
      techTitle: 'Cutting-Edge',
      techTitleAccent: 'Technology',
      techDescription: 'We leverage the latest BIM software and LiDAR scanning equipment to deliver unparalleled accuracy and efficiency.',
      techItems: [
        { title: 'Industry-Leading Software', description: 'Autodesk Revit, Navisworks, and more' },
        { title: 'Advanced 3D Scanners', description: 'Precision LiDAR equipment for accurate data capture' },
        { title: 'Cloud-Based Collaboration', description: 'Real-time project sharing and coordination' },
        { title: 'Managed IT Solutions', description: 'Full-service IT support for trades and Hispanic-owned businesses' },
        { title: 'Cybersecurity & Data Protection', description: 'Threat detection, data encryption, and compliance auditing' },
      ],
      ctaTitle: "Let's Build Something Amazing Together",
      ctaDescription: 'Contact us to discuss how our services can elevate your next project.',
      requestQuote: 'Request a Quote',
    },
    about: {
      heroTitle1: 'Leading the',
      heroTitleAccent: 'Digital Revolution',
      heroTitle2: 'in AEC',
      heroDescription: 'We are passionate about transforming the Architecture, Engineering, and Construction industry through innovative BIM and LiDAR solutions.',
      missionTitle: 'Our Mission',
      missionDescription: 'To empower the AEC industry with cutting-edge BIM and LiDAR solutions that enhance precision, reduce costs, and streamline project delivery from design to construction and beyond.',
      visionTitle: 'Our Vision',
      visionDescription: 'To be the global leader in digital transformation for the built environment, setting new standards for innovation, quality, and sustainability in every project we undertake.',
      valuesTitle: 'Our',
      valuesTitleAccent: 'Core Values',
      valuesSubtitle: 'The principles that guide everything we do and every solution we deliver.',
      values: [
        { title: 'Excellence', description: 'Uncompromising commitment to quality and precision in every project' },
        { title: 'Innovation', description: 'Embracing cutting-edge technology to solve complex challenges' },
        { title: 'Collaboration', description: 'Building strong partnerships with clients and stakeholders' },
        { title: 'Integrity', description: 'Operating with transparency, honesty, and professional ethics' },
      ],
      teamTitle: 'Meet Our',
      teamTitleAccent: 'Leadership',
      teamSubtitle: 'Industry experts driving innovation and excellence in every project.',
      ctaTitle: 'Join Us in Building the Future',
      ctaDescription: "Partner with a team that's committed to your success and the future of the built environment.",
      getInTouch: 'Get in Touch',
    },
    industries: {
      heroTitle: 'Industries We',
      heroTitleAccent: 'Empower',
      heroDescription: 'Delivering cutting-edge BIM and LiDAR solutions across Construction and Real Estate sectors with proven results and measurable value.',
      transforming: 'Transforming',
      keyBenefits: 'Key Benefits:',
      learnMoreSolutions: 'Learn More About Our Solutions',
      applicationsTitle: 'Real-World',
      applicationsTitleAccent: 'Applications',
      applicationsSubtitle: 'See how our technology delivers tangible results across different industry scenarios.',
      useCases: [
        { number: '01', title: 'Pre-Construction Planning', description: 'LiDAR scanning provides accurate site conditions, enabling precise planning and reducing unexpected costs during construction.', tag: 'Construction & Real Estate' },
        { number: '02', title: 'Property Documentation', description: 'Digital twins enable comprehensive property analysis for valuation, due diligence, and portfolio management with unprecedented accuracy.', tag: 'Real Estate' },
      ],
      ctaTitle: 'Ready to See Results in Your Industry?',
      ctaDescription: "Let's discuss how our solutions can deliver measurable value to your specific industry needs.",
      scheduleConsultation: 'Schedule a Consultation',
    },
    contact: {
      heroTitle1: "Let's Start a",
      heroTitleAccent: 'Conversation',
      heroDescription: 'Ready to transform your project with cutting-edge BIM and LiDAR solutions? Get in touch with our team today.',
      getInTouch: 'Get in Touch',
      getInTouchDescription: "Have questions about our services? Want to discuss your project? We're here to help.",
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      businessHours: 'Business Hours',
      sendMessage: 'Send Us a Message',
      fullName: 'Full Name',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      companyName: 'Company Name',
      serviceOfInterest: 'Service of Interest',
      selectService: 'Select a service...',
      serviceOptions: [
        { value: 'architectural', label: 'Architectural Design' },
        { value: 'mep', label: 'MEP Engineering' },
        { value: 'bim', label: 'BIM Modeling' },
        { value: 'lidar', label: 'LiDAR Scanning' },
        { value: 'digital-twin', label: 'Digital Twins' },
        { value: 'coordination', label: 'Construction Coordination' },
        { value: 'managed-it', label: 'Managed IT Services' },
        { value: 'cybersecurity', label: 'Cybersecurity & Data Protection' },
        { value: 'other', label: 'Other' },
      ],
      message: 'Message',
      messagePlaceholder: 'Tell us about your project...',
      submitButton: 'Send Message',
      toastTitle: 'Message Sent!',
      toastDescription: "Thank you for contacting us. We'll get back to you within 24 hours.",
      mapPlaceholder: 'Interactive Map Coming Soon',
    },
  },
  es: {
    nav: {
      home: 'Inicio',
      industries: 'Industrias',
      services: 'Servicios',
      about: 'Nosotros',
      contact: 'Contacto',
      getStarted: 'Comenzar',
    },
    footer: {
      tagline: 'Liderando la transformación digital en Arquitectura, Ingeniería y Construcción con soluciones innovadoras de BIM y LiDAR.',
      quickLinks: 'Enlaces Rápidos',
      ourServices: 'Nuestros Servicios',
      contactUs: 'Contáctenos',
      aboutUs: 'Nosotros',
      allRightsReserved: 'Todos los derechos reservados.',
      privacyPolicy: 'Política de Privacidad',
      termsOfService: 'Términos de Servicio',
      cookiePolicy: 'Política de Cookies',
      servicesList: ['Procesamiento de Nube de Puntos', 'Modelado BIM As-Built', 'Renderizado 3D y Visualización', 'Gemelos Digitales', 'Mapeo LiDAR', 'Escaneo a CAD'],
    },
    home: {
      heroTag: 'Soluciones Avanzadas de Nube de Puntos y Escaneo 3D',
      heroTitle1: 'Excelencia en Nube de Puntos',
      heroTitle2: 'y Precisión',
      heroDescription: 'Liderando la industria con escaneo LiDAR de última generación, procesamiento de nubes de puntos y servicios scan-to-BIM con precisión milimétrica para sus proyectos más exigentes.',
      requestConsultation: 'Solicitar Consulta',
      exploreServices: 'Explorar Servicios',
      pointCloudTitle: 'Servicios Especializados de Nube de Puntos',
      pointCloudSubtitle: 'Desde la captura inicial hasta el entregable final, transformamos la realidad en datos digitales accionables',
      pointCloudServices: [
        { title: 'Modelado BIM As-Built', description: 'Transforme nubes de puntos en modelos BIM inteligentes para renovación y gestión de instalaciones' },
        { title: 'Mapeo LiDAR', description: 'Levantamientos topográficos de alta precisión y modelado de terreno para proyectos de infraestructura' },
        { title: 'Tours Virtuales', description: 'Recorridos inmersivos de 360° para inspección remota y colaboración con partes interesadas' },
        { title: 'Planos CAD 2D', description: 'Planos de planta, elevaciones y secciones precisas extraídas de datos de escaneo' },
        { title: 'Escaneo a CAD', description: 'Conversión integral de datos brutos de nube de puntos a dibujos CAD limpios' },
        { title: 'Escaneo Arquitectónico', description: 'Preservación del patrimonio y documentación detallada de estructuras complejas' },
      ],
      exploreAllServices: 'Explorar Todos los Servicios',
      industriesTitle: 'Industrias que',
      industriesTitleAccent: 'Servimos',
      industriesSubtitle: 'Entregando valor medible en Construcción e Inmobiliaria con soluciones integradas impulsadas por tecnología.',
      learnMore: 'Más Información',
      vizTitle: 'Visualice Su Visión con',
      vizTitleAccent: 'Renderizado 3D y Gemelos Digitales',
      vizSubtitle: 'Dé vida a sus proyectos con renderizados fotorrealistas y réplicas digitales inteligentes',
      audiences: [
        {
          title: 'Desarrolladores Inmobiliarios',
          description: 'Presente propiedades antes de la construcción con visualizaciones impresionantes que impulsan las preventas y la confianza de los inversores.',
          benefits: ['Marketing Pre-construcción', 'Presentaciones a Inversores', 'Vistas de Personalización'],
        },
        {
          title: 'Aplicaciones Arquitectónicas y MEP',
          description: 'Modelos as-built precisos y documentación MEP detallada que agilizan la coordinación de diseño, reducen conflictos y aceleran la entrega de proyectos.',
          benefits: ['Capturar Condiciones del Sitio', 'Coordinación de Diseño', 'Comparar Obra Construida con Planos'],
        },
        {
          title: 'Contratistas',
          description: 'Gane más licitaciones con visualizaciones profesionales y gestione proyectos eficientemente con gemelos digitales.',
          benefits: ['Visuales para Propuestas', 'Planificación de Construcción', 'Seguimiento de Progreso'],
        },
      ],
      whatWeDeliver: 'Lo Que Entregamos',
      deliverables: [
        'Renderizados 3D fotorrealistas para marketing y presentaciones',
        'Visualizaciones interactivas de planos con múltiples opciones de diseño',
        'Gemelos digitales con integración de datos en tiempo real',
        'Recorridos virtuales y experiencias inmersivas',
        'Animaciones de fases de construcción',
        'Estudios de materiales e iluminación',
      ],
      fromLabel: 'Del',
      conceptToReality: 'Concepto a la Realidad',
      conceptDescription: 'Transforme sus ideas en visuales impactantes que comunican la intención de diseño e impulsan el éxito del proyecto.',
      exploreVisualization: 'Explorar Servicios de Visualización',
      whyChooseTitle: '¿Por Qué Elegir',
      whyChooseAccent: 'Delta Studio?',
      whyChooseDescription: 'Entregamos soluciones integradas impulsadas por tecnología que transforman la forma en que diseña, construye y gestiona proyectos. Nuestro compromiso con la calidad, precisión e innovación nos distingue.',
      whyChooseItems: [
        { title: 'Excelencia Técnica', description: 'Tecnología BIM y LiDAR de vanguardia implementada por expertos certificados con décadas de experiencia combinada.' },
        { title: 'Resultados Medibles', description: 'Historial comprobado de reducción de costos, minimización de retrabajos y aceleración de cronogramas de proyecto.' },
        { title: 'Socio de Confianza', description: 'Más de 500 proyectos exitosos en sectores residencial, comercial, industrial e institucional.' },
      ],
      clientSatisfaction: 'Satisfacción del Cliente',
      ctaTitle: '¿Listo para Transformar Su Proyecto?',
      ctaDescription: 'Hablemos de cómo nuestras soluciones BIM y LiDAR pueden ayudarle a alcanzar sus objetivos con precisión y eficiencia.',
      viewServices: 'Ver Servicios',
    },
    services: {
      heroTitle1: 'Servicios Integrales de',
      heroTitleAccent: 'BIM y LiDAR',
      heroTitle2: '',
      heroDescription: 'Desde el diseño hasta la construcción y más allá, ofrecemos soluciones digitales de extremo a extremo que transforman la entrega de proyectos y mejoran la colaboración.',
      featuredTag: 'Servicios Destacados',
      signatureTitle: 'Nuestras',
      signatureTitleAccent: 'Soluciones Insignia',
      signatureSubtitle: 'Capacidades líderes en la industria en procesamiento de nubes de puntos, visualización y tecnología de gemelos digitales.',
      whyChooseService: '¿Por Qué Elegir Este Servicio?',
      serviceBenefits: {
        '1': [
          { title: 'Precisión Milimétrica', description: 'Capture la realidad con precisión de hasta ±2mm' },
          { title: 'Captura Rápida de Datos', description: 'Escanee grandes instalaciones en horas, no en días' },
          { title: 'Documentación Completa', description: 'Cada detalle capturado para referencia futura' },
          { title: 'Entregables Versátiles', description: 'Modelos BIM, dibujos CAD, tours virtuales y más' },
        ],
        '8': [
          { title: 'Calidad Fotorrealista', description: 'Visuales impresionantes que muestran la intención de diseño perfectamente' },
          { title: 'Listo para Marketing', description: 'Renderizados profesionales para materiales de venta y marketing' },
          { title: 'Comunicación con Clientes', description: 'Ayude a los clientes a visualizar resultados finales antes de construir' },
          { title: 'Validación de Diseño', description: 'Valide decisiones de diseño temprano en el proceso' },
        ],
        '9': [
          { title: 'Monitoreo en Tiempo Real', description: 'Rastree el rendimiento y condiciones de los activos 24/7' },
          { title: 'Mantenimiento Predictivo', description: 'Anticipe problemas antes de que se conviertan en fallas' },
          { title: 'Ahorro de Costos', description: 'Optimice operaciones y reduzca costos de mantenimiento' },
          { title: 'Gestión del Ciclo de Vida', description: 'Gestione activos desde la construcción hasta el desmantelamiento' },
        ],
      },
      portfolioTitle: 'Portafolio Completo de',
      portfolioTitleAccent: 'Servicios',
      portfolioSubtitle: 'Desde el escaneo inicial hasta el entregable final, ofrecemos soluciones integrales para cada necesidad del proyecto.',
      keyFeatures: 'Características Clave:',
      processTitle: 'Nuestro',
      processTitleAccent: 'Proceso',
      processSubtitle: 'Un enfoque estructurado para entregar excelencia en cada etapa de su proyecto.',
      processSteps: [
        { step: '01', title: 'Descubrimiento', description: 'Comenzamos visitando su propiedad para comprender sus características únicas y determinar las mejores áreas de enfoque. Esto nos ayuda a asegurar que cada detalle importante se capture para un modelo preciso.' },
        { step: '02', title: 'Planificación', description: 'Luego, elaboramos un plan a medida para su proyecto, seleccionando el equipo ideal e identificando los puntos de escaneo perfectos. Nuestro objetivo es crear un proceso fluido que garantice precisión y eficiencia.' },
        { step: '03', title: 'Ejecución', description: 'Nuestro equipo se pone a trabajar, escaneando cuidadosamente la propiedad desde múltiples ángulos. Con nuestro equipo experto y técnicas, capturamos cada detalle, asegurando una representación 3D de alta calidad y precisión.' },
        { step: '04', title: 'Entrega', description: 'Una vez procesados los datos de escaneo, entregamos un impresionante modelo 3D interactivo listo para explorar, compartir o integrar en su proyecto. Proporcionando documentación completa y soporte.' },
      ],
      techTitle: 'Tecnología de',
      techTitleAccent: 'Vanguardia',
      techDescription: 'Aprovechamos el software BIM más reciente y equipos de escaneo LiDAR para ofrecer una precisión y eficiencia sin igual.',
      techItems: [
        { title: 'Software Líder en la Industria', description: 'Autodesk Revit, Navisworks y más' },
        { title: 'Escáneres 3D Avanzados', description: 'Equipos LiDAR de precisión para captura precisa de datos' },
        { title: 'Colaboración en la Nube', description: 'Compartición y coordinación de proyectos en tiempo real' },
        { title: 'Soluciones IT Administradas', description: 'Soporte IT completo para negocios de oficios e hispanos' },
        { title: 'Ciberseguridad y Protección de Datos', description: 'Detección de amenazas, cifrado de datos y auditoría de cumplimiento' },
      ],
      ctaTitle: 'Construyamos Algo Increíble Juntos',
      ctaDescription: 'Contáctenos para hablar sobre cómo nuestros servicios pueden elevar su próximo proyecto.',
      requestQuote: 'Solicitar Cotización',
    },
    about: {
      heroTitle1: 'Liderando la',
      heroTitleAccent: 'Revolución Digital',
      heroTitle2: 'en AEC',
      heroDescription: 'Nos apasiona transformar la industria de Arquitectura, Ingeniería y Construcción a través de soluciones innovadoras de BIM y LiDAR.',
      missionTitle: 'Nuestra Misión',
      missionDescription: 'Empoderar a la industria AEC con soluciones de BIM y LiDAR de vanguardia que mejoran la precisión, reducen costos y agilizan la entrega de proyectos desde el diseño hasta la construcción y más allá.',
      visionTitle: 'Nuestra Visión',
      visionDescription: 'Ser el líder global en transformación digital para el entorno construido, estableciendo nuevos estándares de innovación, calidad y sostenibilidad en cada proyecto que emprendemos.',
      valuesTitle: 'Nuestros',
      valuesTitleAccent: 'Valores Fundamentales',
      valuesSubtitle: 'Los principios que guían todo lo que hacemos y cada solución que entregamos.',
      values: [
        { title: 'Excelencia', description: 'Compromiso inquebrantable con la calidad y precisión en cada proyecto' },
        { title: 'Innovación', description: 'Adoptando tecnología de vanguardia para resolver desafíos complejos' },
        { title: 'Colaboración', description: 'Construyendo alianzas sólidas con clientes y partes interesadas' },
        { title: 'Integridad', description: 'Operando con transparencia, honestidad y ética profesional' },
      ],
      teamTitle: 'Conozca Nuestro',
      teamTitleAccent: 'Liderazgo',
      teamSubtitle: 'Expertos de la industria impulsando innovación y excelencia en cada proyecto.',
      ctaTitle: 'Únase a Nosotros para Construir el Futuro',
      ctaDescription: 'Asóciese con un equipo comprometido con su éxito y el futuro del entorno construido.',
      getInTouch: 'Contáctenos',
    },
    industries: {
      heroTitle: 'Industrias que',
      heroTitleAccent: 'Impulsamos',
      heroDescription: 'Ofreciendo soluciones de BIM y LiDAR de vanguardia en los sectores de Construcción e Inmobiliaria con resultados comprobados y valor medible.',
      transforming: 'Transformando',
      keyBenefits: 'Beneficios Clave:',
      learnMoreSolutions: 'Más Sobre Nuestras Soluciones',
      applicationsTitle: 'Aplicaciones del',
      applicationsTitleAccent: 'Mundo Real',
      applicationsSubtitle: 'Vea cómo nuestra tecnología ofrece resultados tangibles en diferentes escenarios industriales.',
      useCases: [
        { number: '01', title: 'Planificación Pre-Construcción', description: 'El escaneo LiDAR proporciona condiciones precisas del sitio, permitiendo una planificación precisa y reduciendo costos inesperados durante la construcción.', tag: 'Construcción e Inmobiliaria' },
        { number: '02', title: 'Documentación de Propiedades', description: 'Los gemelos digitales permiten un análisis integral de propiedades para valuación, debida diligencia y gestión de portafolios con precisión sin precedentes.', tag: 'Inmobiliaria' },
      ],
      ctaTitle: '¿Listo para Ver Resultados en Su Industria?',
      ctaDescription: 'Hablemos de cómo nuestras soluciones pueden entregar valor medible a sus necesidades específicas de la industria.',
      scheduleConsultation: 'Programar una Consulta',
    },
    contact: {
      heroTitle1: 'Iniciemos una',
      heroTitleAccent: 'Conversación',
      heroDescription: '¿Listo para transformar su proyecto con soluciones de BIM y LiDAR de vanguardia? Póngase en contacto con nuestro equipo hoy.',
      getInTouch: 'Contáctenos',
      getInTouchDescription: '¿Tiene preguntas sobre nuestros servicios? ¿Quiere hablar de su proyecto? Estamos aquí para ayudar.',
      email: 'Correo',
      phone: 'Teléfono',
      address: 'Dirección',
      businessHours: 'Horario de Atención',
      sendMessage: 'Envíenos un Mensaje',
      fullName: 'Nombre Completo',
      emailAddress: 'Correo Electrónico',
      phoneNumber: 'Número de Teléfono',
      companyName: 'Nombre de Empresa',
      serviceOfInterest: 'Servicio de Interés',
      selectService: 'Seleccione un servicio...',
      serviceOptions: [
        { value: 'architectural', label: 'Diseño Arquitectónico' },
        { value: 'mep', label: 'Ingeniería MEP' },
        { value: 'bim', label: 'Modelado BIM' },
        { value: 'lidar', label: 'Escaneo LiDAR' },
        { value: 'digital-twin', label: 'Gemelos Digitales' },
        { value: 'coordination', label: 'Coordinación de Construcción' },
        { value: 'managed-it', label: 'Servicios IT Administrados' },
        { value: 'admin', label: 'Servicios Administrativos' },
        { value: 'other', label: 'Otro' },
      ],
      message: 'Mensaje',
      messagePlaceholder: 'Cuéntenos sobre su proyecto...',
      submitButton: 'Enviar Mensaje',
      toastTitle: '¡Mensaje Enviado!',
      toastDescription: 'Gracias por contactarnos. Le responderemos dentro de 24 horas.',
      mapPlaceholder: 'Mapa Interactivo Próximamente',
    },
  },
};

export default translations;
